export const CELEBRUS_LOGIN_STATE_KEY = 'celebrusLoginState';
export const PORTAL_LOGIN_STATE_KEY = 'portalLoginState';
export const NAVBAR_HEADER_HEIGHT = 80;
export const DNB_TENANT_ID = '4cbfea0a-b872-47f0-b51c-1c64953c3f0b';

const EVENT_CATALOG_URLS = {
  sit: 'https://event-catalog-sit.tech.dnb.no',
  uat: 'https://event-catalog-uat.tech.dnb.no',
  prod: 'https://event-catalog-prod.tech.dnb.no',
};

export function getEventCatalogBaseUrl(environmentSlug: string): string | null {
  const lowerSlug = environmentSlug.toLowerCase();
  if (lowerSlug.includes('prod')) {
    return EVENT_CATALOG_URLS.prod;
  }
  if (lowerSlug.includes('uat')) {
    return EVENT_CATALOG_URLS.uat;
  }
  if (lowerSlug.includes('sit')) {
    return EVENT_CATALOG_URLS.sit;
  }
  return null;
}
